import React, { useEffect, useState } from 'react';
import { T } from '../../../traks';
import { Container, Row, Col, Table } from 'reactstrap';
import { determineOrderStatus, determinePaymentMethod } from './ThankYouUtils';
import { formatDate, formatPrice } from '../Globals/GlobalUtils';
import { determineExtraOptionName, determinePackageDescription, determinePackageName } from '../Cart/CartUtils';

export const ThankYou = ({ cart, orderDetails, setCart, setGame }) => {
    const [expirationDate, setExpirationDate] = useState(new Date());

    const vatRate = 25;
    const vatFactor = 1 + vatRate / 100;

    // Run once on mount: clear persisted cart and reset state after successful purchase
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (cart && cart.lines && cart.lines.length > 0 && cart.lines[0] && cart.lines[0].expirationDate) {
            setExpirationDate(cart.lines[0].expirationDate);
        }

        localStorage.removeItem('cart');
        localStorage.removeItem('cart-game');
        setCart({});
        setGame(null);
    }, []);

    return (
        <Container className='p-4'>
            <Row>
                <Col>
                    <span className='mt-3'><T>Your order with number: </T> #{orderDetails.paymentId} <T>has been successfully processed!</T></span>
                </Col>
            </Row>
            <Row className='mt-3'>
                <Col>
                    <b><T>Order details</T></b>
                </Col>
            </Row>
            <Row className='checkout-table-container'>
                <Table striped bordered hover>
                    <tbody>
                        <tr>
                            <td><T>Order number</T></td>
                            <td><T>{orderDetails.paymentId}</T></td>
                        </tr>
                        <tr>
                            <td><T>Payment method</T></td>
                            <td>{determinePaymentMethod(orderDetails.payment.paymentMethod)}</td>
                        </tr>
                        <tr>
                            <td><T>Order status</T></td>
                            <td>{determineOrderStatus(orderDetails.payment.paymentMethod)}</td>
                        </tr>
                        {orderDetails.payment.order.game && (
                            <tr>
                                <td><T>Game Upgrade</T></td>
                                <td>
                                    {orderDetails.payment.order.game}
                                </td>
                            </tr>
                        )}
                        {orderDetails.payment.order.package_id && (
                            <tr>
                                <td><T>Package: </T></td>
                                <td>{determinePackageName(orderDetails.payment.order.package_id)} {determinePackageDescription(orderDetails.payment.order.package_id)}</td>
                            </tr>
                        )}
                        {orderDetails.payment.order.extra_option_id && (
                            <tr>
                                <td><T>Extra Option: </T></td>
                                <td>{determineExtraOptionName(orderDetails.payment.order.extra_option_id)}</td>
                            </tr>
                        )}
                        <tr>
                            <td><T>Premium Key</T></td>
                            <td>
                                <T>Players: </T> {orderDetails.payment.order.num_keys} <T>Months: </T>
                                {orderDetails.payment.order.num_months}
                            </td>
                        </tr>
                        <tr>
                            <td><T>Start Date</T></td>
                            <td>
                                {formatDate(new Date(orderDetails.payment.order.start_date))}
                            </td>
                        </tr>
                        <tr>
                            <td><T>Premium valid until</T></td>
                            <td>
                                {formatDate(new Date(expirationDate))}
                            </td>
                        </tr>
                        <tr>
                            <td><T>VAT</T></td>
                            <td>{vatRate}%</td>
                        </tr>
                        <tr>
                            <td><T>Total price</T></td>
                            <td>
                                {formatPrice(orderDetails.payment.order.total_price)} {orderDetails.order.currency}&nbsp;
                                ({formatPrice((orderDetails.order.lines[0].unitprice / 100) / vatFactor)} {orderDetails.order.currency} <T>excl. VAT</T>)
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </Row>
            <Row>
                <Col>
                    <span className='mt-3'><T>An e-mail with further details has been sent to: </T>{orderDetails.payment.email}</span>
                </Col>
            </Row>
        </Container>
    )
}



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/ThankYou/ThankYou.js